// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IEmissionTestResultType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class EmissionTestResultType implements IEmissionTestResultType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Pass EmissionTestResultType
	**/
    get P(): IEmissionTestResultType {
        return this.FromId(14);
    }
    /**
		Returns Fail EmissionTestResultType
	**/
    get F(): IEmissionTestResultType {
        return this.FromId(15);
    }
    /**
		Returns Referee Pass EmissionTestResultType
	**/
    get RP(): IEmissionTestResultType {
        return this.FromId(16);
    }
    /**
		Returns Waiver Pass EmissionTestResultType
	**/
    get WP(): IEmissionTestResultType {
        return this.FromId(17);
    }
    /**
		Returns Waiver Granted EmissionTestResultType
	**/
    get WG(): IEmissionTestResultType {
        return this.FromId(18);
    }
    /**
		Returns Referee Fail EmissionTestResultType
	**/
    get RF(): IEmissionTestResultType {
        return this.FromId(19);
    }
    /**
		Returns Waiver Denial EmissionTestResultType
	**/
    get WD(): IEmissionTestResultType {
        return this.FromId(20);
    }
    /**
		Returns Military Exemption EmissionTestResultType
	**/
    get MilitaryExemption(): IEmissionTestResultType {
        return this.FromId(21);
    }
    /**
		Returns Non-Compliance  EmissionTestResultType
	**/
    get NC(): IEmissionTestResultType {
        return this.FromId(22);
    }
    /**
		Returns 1 Year Out Of State Exemption EmissionTestResultType
	**/
    get E1(): IEmissionTestResultType {
        return this.FromId(23);
    }
    /**
		Returns 2 Year Out of State Exemption EmissionTestResultType
	**/
    get E2(): IEmissionTestResultType {
        return this.FromId(24);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('14', { id: 14, value: 'P', displayValue: 'Pass', description: 'Pass', sortOrder: 999999, active: true });
        this._dictionary.add('15', { id: 15, value: 'F', displayValue: 'Fail', description: 'Fail', sortOrder: 999999, active: true });
        this._dictionary.add('16', { id: 16, value: 'RP', displayValue: 'Referee Pass', description: 'Referee Pass', sortOrder: 999999, active: true });
        this._dictionary.add('17', { id: 17, value: 'WP', displayValue: 'Waiver Pass', description: 'Waiver Pass', sortOrder: 999999, active: true });
        this._dictionary.add('18', { id: 18, value: 'WG', displayValue: 'Waiver Granted', description: 'Waiver Granted', sortOrder: 999999, active: true });
        this._dictionary.add('19', { id: 19, value: 'RF', displayValue: 'Referee Fail', description: 'Referee Fail', sortOrder: 999999, active: true });
        this._dictionary.add('20', { id: 20, value: 'WD', displayValue: 'Waiver Denial', description: 'Waiver Denial', sortOrder: 999999, active: true });
        this._dictionary.add('21', { id: 21, value: 'MilitaryExemption', displayValue: 'Military Exemption', description: 'Military Exemption', sortOrder: 999999, active: true });
        this._dictionary.add('22', { id: 22, value: 'NC', displayValue: 'Non-Compliance ', description: 'Non-Compliance ', sortOrder: 999999, active: true });
        this._dictionary.add('23', { id: 23, value: 'E1', displayValue: '1 Year Out Of State Exemption', description: 'Out Of State Exemption (1yr) Director\'s Certificate', sortOrder: 999999, active: true });
        this._dictionary.add('24', { id: 24, value: 'E2', displayValue: '2 Year Out of State Exemption', description: 'Out Of State Exemption (2yr) Director\'s Certificate', sortOrder: 999999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IEmissionTestResultType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IEmissionTestResultType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IEmissionTestResultType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IEmissionTestResultType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IEmissionTestResultType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
